import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  id: null,
};

const slice = createSlice({
  name: 'billboard',
  initialState,
  reducers: {
    setBillboard: (state, { payload }) => ({ ...state, id: payload }),
    restore: () => initialState,
  },
});

export const { restore, setBillboard } = slice.actions;

export const selectBillboard = (state) => state.billboard;

export default slice.reducer;
